(ns ui.components.rich-text.view
  (:require
   [clojure.string :as string]
   ["draft-js" :refer [EditorState ContentState convertToRaw]]
   ["draftjs-to-html" :as draftToHtml]
   ["html-to-draftjs" :default htmlToDraft]
   [frontend.utils :as fu]
   [reagent.core :as r]
   [ui.util :as uu]
   ["react-draft-wysiwyg" :refer [Editor]]))

(def no-align-toolbar-options
  {"options" ["inline" "list"]
   "inline"  {"options" ["bold" "italic" "underline"]}})

(defn custom-toolbar-options
  [link?]
  (merge {"options"   (concat
                       ["inline" "list" "textAlign"]
                       (when link? ["link"]))
          "textAlign" {"inDropdown" false
                       "className"  "rounded grid grid-cols-4 divide-x divide-input-light-border-paler border border-solid border-input-light-border-paler *:bg-transparent *:border-0 *:rounded-none *:shadow-none *:hover:bg-input-light  *:m-0 m-0"}
          "list"      {"options"   ["unordered" "ordered"]
                       "indent"    {"className" "hello-list"}
                       "className" "rounded grid grid-cols-2 divide-x divide-input-light-border-paler border border-solid border-input-light-border-paler *:bg-transparent *:border-0 *:rounded-none *:shadow-none *:hover:bg-input-light  *:m-0 m-0"}
          "inline"    {"options"   ["bold" "italic" "underline"]
                       "className" "rounded grid grid-cols-3 divide-x divide-input-light-border-paler border border-solid border-input-light-border-paler *:bg-transparent *:border-0 *:rounded-none *:shadow-none *:hover:bg-input-light  *:m-0 m-0"}}
         (when link?
           {"link" {"options"             ["link"]
                    "defaultTargetOption" "_blank"
                    "popupClassName"      ""}})))

(defn empty-editor-value?
  [v]
  (let [value (->> v
                   (str)
                   (string/trim))]
    (or (not value)
        (empty? value)
        (= value "<p></p>")
        (= value "<p><br></p>"))))

(defn sanitize-html-for-draftjs
  "Removes HTML elements that html-to-draftjs does not support"
  [html]
  (when html
    (-> html
        (string/replace #"<figure[^>]*>" "")
        (string/replace #"</figure>" "")
        (string/replace #"<figcaption[^>]*>.*?</figcaption>" ""))))

(defn create-editor-state
  [value]
  (let [sanitized-value (or (not-empty (sanitize-html-for-draftjs value))
                            "<p></p>")
        content-state (.createFromBlockArray ContentState
                                             (-> sanitized-value
                                                 (string/replace #"<u>" "<ins>")
                                                 (string/replace #"</u>" "</ins>")
                                                 (htmlToDraft)))
        editor-state (.createWithContent EditorState content-state)]
    editor-state))

(defn viewer
  [_value _styles]
  (r/create-class
   {:display-name "rich-text-editor"
    :reagent-render
    (fn [value styles]
      [:> Editor
       {:editorState         (create-editor-state value)
        :onEditorStateChange identity
        :onFocus             identity
        :spellCheck          true
        :readOnly            true
        :editorStyle         (clj->js styles)
        :toolbar             no-align-toolbar-options
        :toolbarHidden       true
        :placeholder         ""
        :editorClassName     ""}])}))


(defn editor
  [{:keys [value _placeholder _class _editor-class _on-change _on-focus _on-blur _toolbar-custom-buttons _disable-pasted-styles? _link?]}]
  (let [editor-state-atom (r/atom (create-editor-state value))
        local-state (r/atom {})]
    (r/create-class
     {:display-name "rich-text-editor"
      :reagent-render
      (fn [{:keys [placeholder class editor-class on-change on-focus on-blur toolbar-custom-buttons disable-pasted-styles? link?]}]
        [:> Editor
         (merge
          {:editorState         @editor-state-atom
           :onEditorStateChange (fn [new-editor-state]
                                  (reset! editor-state-atom new-editor-state))
           :onChange            (fn [_state]
                                  (let [content (.getCurrentContent @editor-state-atom)
                                        new-html-content (draftToHtml (convertToRaw content))]
                                    (when (fn? on-change)
                                      (on-change new-html-content))))
           :spellCheck          true
           :readOnly            false
           :toolbar             (custom-toolbar-options link?)
           :onFocus             (fn [e]
                                  (swap! local-state assoc :focus? true)
                                  (when (fn? on-focus)
                                    (on-focus e)))
           :onBlur              (fn [e]
                                  (swap! local-state dissoc :focus?)
                                  (when (fn? on-blur)
                                    (on-blur e)))
           :toolbarHidden       false
           :placeholder         (or placeholder "")
           :wrapperClassName    (fu/cs "p-0 border-0 rounded" class)
           :toolbarClassName    "border-b-0 border-x border-t border-solid border-input-light-border-paler gap-3 bg-base-light text-base-light-text"
           :editorClassName     (uu/cm "flex-1 border rounded-bl rounded-br rounded-tl-none rounded-tr-none border-solid border-input-light-border-paler hover:border-input-light-border focus-within:border-input-light-border focus-within:ring-1 focus-within:ring-input-light-border bg-input-light text-input-light-text"
                                       editor-class)}
          (when toolbar-custom-buttons
            {:toolbarCustomButtons toolbar-custom-buttons})
          (when disable-pasted-styles?
            {:stripPastedStyles true}))])})))

